export default "__VITE_ASSET__tHR2jfGO__"